export { PageTopicsComponent as PageTopics } from './component';



// WEBPACK FOOTER //
// ./src/pages/topics/index.tsx